import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles/HintButton.module.css';

interface HintButtonProps {
	onClick: () => void;
}

export const HintButton = ({ onClick }: HintButtonProps) => {
	return (
		<button className={styles.hintButton} onClick={onClick}>
			<FormattedMessage id="button.hint" />
		</button>
	);
};
